import { filter } from 'rxjs/operators';
import { locale } from './../../../../navigation/i18n/tr';
import { EmployeeService } from 'app/modules/employee/services/employee.service';
import { EmpresaService } from 'app/modules/company-view/services/empresa.service';
import { Usuario } from 'app/modules/common/types/usuario.type';
import { SharedService } from 'app/modules/common/services/shared-service';
import { TaskManagementService } from './../../../task/services/task-management.service';
import { UntypedFormGroup } from '@angular/forms';
import { AuthComponentModel } from 'app/modules/common/entities/AuthComponentModel';
import { DoctorService } from 'app/modules/doctor/services/doctor.service';
import { TaskSaveService } from 'app/modules/task/services/task-save.service';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { values } from 'lodash';
import Utils from 'app/Utils';

@Component({
    selector: 'app-globle-author',
    templateUrl: './globle-author.component.html',
    styleUrls: ['./globle-author.component.scss'],
    standalone: false
})
export class GlobleAuthorComponent implements OnInit {

  
  @Input() authorTypes:string;//"GCM" examples

  @Input() moduleName:string;

  @Input() authComponentModel: AuthComponentModel;

  @Input() authorFormGroup: UntypedFormGroup;

  @Input() nextTaskFormGroup: UntypedFormGroup;

  @Input() solicitudFormGroup: UntypedFormGroup;

  @Input() gestionFormGroup: UntypedFormGroup;

  @Input() editAuthorFormGroup: UntypedFormGroup;
  
  @Input() citarBajaNueva:string;
  @Input() bajaNueva:string;

  @Input() LeaveInfo:any;

  @Output() AutorChanged = new EventEmitter();
  @Output() UserChanged = new EventEmitter();
  @Output() MedicoChanged = new EventEmitter();
  @Output() CoordinatorChanged = new EventEmitter();

  @ViewChild('medicoSelect')doctorSearchInput :ElementRef
  authorList : any;

  authorListWithPremist:any=[];

  userList: any = [];

  medicoList: any = [];
  _medicoList :any=[];
  UserModal = []
  coordinatorList:any =[];

  currentUser:any;

  loggedUserTipoAutor:any;

  isAuthorShow:boolean=true;

  selectedTask:number;

  employeeId:any;
  employee:any;
  company:any;

  defaultValue = '';
  defaultMedicoValue='';

  dropDownActivate = {
    gestion: false,
    medico: false,
    coordinador: false,
    due: false,
  };

  constructor
  (
    public taskService: TaskSaveService,
    private doctorService: DoctorService,
    public taskManagementService: TaskManagementService,
    private sharedService: SharedService,
    private empresaService: EmpresaService,
    private medicoService: DoctorService,
    private employeeService: EmployeeService,
    private taskSaveService: TaskSaveService,
  ) { 
    
    
  }

  ngOnInit(): void {
    this.LoadMedicoDropdownList()
    this.LoadUserDropdownList()
    this.LoadCoordinatorDropdownList()
    this.LoadAuthorList();
    if(this.moduleName=='task-managemnt')
    {
      this.LoadAllInformations();
      this.selectedTask=this.taskManagementService.TaskManagementForm.get('Tarea')?.value;     
      this.taskManagementService.TaskManagementForm.get("Tarea").valueChanges.subscribe(x => {
        this.selectedTask=this.taskManagementService.TaskManagementForm.get('Tarea')?.value;
        this.SetFormValues();
      })
      this.SetFormValues();
    }
    else if(this.moduleName=='task-selection')
    {
      this.authorFormGroup.get('Tipo').valid
      this.authorFormGroup.get('Tipo').clearValidators();
    }
    else if(this.moduleName=='proxima-actuacion')
    {
      this.LoadAllInformations();
      this.selectedTask=this.nextTaskFormGroup.get('Task')?.value;     
      this.nextTaskFormGroup.get("Task").valueChanges.subscribe(x => {
        this.selectedTask=this.nextTaskFormGroup.get('Task')?.value;
        this.SetFormValues();
      })
      this.SetFormValues();
    }
    else if(this.moduleName=='solicitud-actuation')
    {
      this.LoadAllInformations();
      this.SetFormValues();
      this.SetFormValues();
    }
    else if(this.moduleName=='app-gestion' || this.moduleName ==='app-orden')
    {
      this.LoadAllInformations();
      this.selectedTask=this.gestionFormGroup.get('Type')?.value;     
      this.gestionFormGroup.get("Type").valueChanges.subscribe(x => {
        this.selectedTask=this.gestionFormGroup.get('Type')?.value;

        if(this.gestionFormGroup.get('Type')?.value=='19999')
        {
          this.authorFormGroup.get(['Tipo']).setValue('G');
          this.authorTypes='G';
        }
        else if(this.gestionFormGroup.get('Type')?.value=='29999')
        {
          this.authorFormGroup.get(['Tipo']).setValue('C');
          this.authorTypes='C';
        }
        else if(this.gestionFormGroup.get('Type')?.value=='39999')
        {
          this.authorFormGroup.get(['Tipo']).setValue('M');
          this.authorTypes='M';
        }
        else if(this.gestionFormGroup.get('Type')?.value=='49999')
        {
          this.authorFormGroup.get(['Tipo']).setValue('E');
          this.authorTypes='E';
        }
        else if(this.gestionFormGroup.get('Type')?.value=='59999')
        {
          this.authorFormGroup.get(['Tipo']).setValue('U');
          this.authorTypes='U';
        }
        else if(this.gestionFormGroup.get('Type')?.value=='49901')
        {
          this.authorTypes='GMC';
        }
        
        this.LoadAuthorList();
        this.SetFormValues();
      })
      this.SetFormValues();
    }
    else if(this.moduleName=='author-dialog')
    {
      this.LoadAllInformations();
      this.SetFormValues();
      this.SetFormValues();
    }
   
  }

  noCompareFunction(){ return 0;}

  LoadAllInformations()
  {
    this.employeeId = parseInt(localStorage.getItem('EmplooyeeID'));
    this.employeeService.GetTrabajador(this.employeeId).subscribe(res=>{
      this.employee=res.result;
      if(res)
      {
        this.empresaService.GetEmpresaById(this.employee.empresaId).subscribe(res=>{
          this.company = res.result;
           this.SetFormValues();
        });
      }
    })
    

  }
  SearchDoctors()
  {
    const searchInput=this.doctorSearchInput.nativeElement.value ?
      this.doctorSearchInput.nativeElement.value.toLowerCase():'';

    this._medicoList =this.medicoList.filter(m=>{
      if(m.viewValue!=null)
      {
      const viewValue : string=m.viewValue.toLowerCase();
      return viewValue.indexOf(searchInput) > -1;
      }
    })
    
  }
  LoadAuthorList(): void {
    
    this.authorListWithPremist=[];
    
    this.isAuthorShow=true;
    if(this.moduleName === 'app-orden'){
      this.authorList = [
        { order: 1, value: 'G', viewValue: 'Gestión' },
        { order: 3, value: `C`, viewValue: 'Coordinador' },
    ];
    }else{
      this.authorList = [
        { order: 1, value: 'G', viewValue: 'Gestión' },
        { order: 2, value: `M`, viewValue: 'Médico' },
        { order: 3, value: `C`, viewValue: 'Coordinador' },
        { order: 4, value: `E`, viewValue: 'Empresa' },
        { order: 5, value: `U`, viewValue: 'Mutua' },
        { order: 6, value: `D`, viewValue: 'DUE' },
    ];
    }

    const pramitLenght = this.authorTypes.length;
   
    this.authorList.forEach(element => {
      if(this.authorTypes.includes(element.value))
      {
        this.authorListWithPremist.push(element)
        if(pramitLenght==1)
        {
          this.isAuthorShow=false;
          this.defaultValue=element.value;
          this.OnAuthorChange(element)
        }   
      }
    });
  };

  SetFormValues()
  {
    const currentUser = this.sharedService.getCurrentUser() as Usuario;
        if(this.moduleName=='task-selection')
        {
          
        }
        else if(this.moduleName=='task-managemnt')
        {
            if(this.selectedTask >= 30000 && this.selectedTask <= 39999)
            {
                if(this.selectedTask==31109 && this.bajaNueva=="CONTACTO")
                {
                  this.authorFormGroup.get(['Tipo']).setValue('M');
                  
                  this.OnAuthorChange(this.authorList[1])
                  if(this.company)
                  {
                    this.authorFormGroup.get(['MedicoId']).setValue(this.company.primerContacto);
                    this.authorFormGroup.get(['Medico']).setValue(this.company.primerContacto);
                    var user = this.GetMedicoByFind(this.company.primerContacto);
                    this.authorFormGroup.get(['Nombre']).setValue(user.viewValue);
                  }

                }
                else if(this.selectedTask==30109 && this.bajaNueva=="DOMICILIO")
                {
                  this.authorFormGroup.get(['Tipo']).setValue('M');
                  
                  this.OnAuthorChange(this.authorList[1])
                  if(this.company)
                  {
                    this.authorFormGroup.get(['MedicoId']).setValue(this.company.medicoId);
                    this.authorFormGroup.get(['Medico']).setValue(this.company.medicoId);
                    var user = this.GetMedicoByFind(this.company.medicoId);
                    this.authorFormGroup.get(['Nombre']).setValue(user.viewValue);
                  }
                }
                else
                {
                  this.authorFormGroup.get(['Tipo']).setValue('M');
                  this.LoadMedicoDropdownList()
                  this.OnAuthorChange(this.authorList[1])
                    // if(Boolean(currentUser.medicoId)) // current user is doctor
                    // {
                      this.authorFormGroup.get(['MedicoId']).setValue(this.LeaveInfo.medicoId);
                      var medico = this.GetMedicoByFind(this.LeaveInfo.medicoId);
                      this.authorFormGroup.get(['Medico']).setValue(this.LeaveInfo.medicoId);
                      if(medico)
                      {
                        this.authorFormGroup.get(['Nombre']).setValue(medico.viewValue);
                      }
                      
                    // }
                    // else // current user is not doctor
                    // {
                    //   if(this.company)
                    //   {
                    //     this.authorFormGroup.get(['MedicoId']).setValue(this.company.medicoId.toString());
                    //     var medico = this.GetMedicoByFind(this.company.medicoId);
                    //     this.authorFormGroup.get(['Medico']).setValue(this.company.medicoId);
                    //     if(medico)
                    //     {
                    //     this.authorFormGroup.get(['Nombre']).setValue(medico.viewValue);
                    //     }
                    //   }
                    // }
                }

            }
            else
            {
                this.LoadUserDropdownList()

                if(this.selectedTask==13001 && this.citarBajaNueva=="S")
                {
                    this.authorFormGroup.get(['Tipo']).setValue('G');
                  
                    this.OnAuthorChange(this.authorList[0])
                    if(this.company)
                    {
                      this.authorFormGroup.get(['MedicoId']).setValue(null);
                      var user = this.GetUserByString(this.company.administrativa);
                      this.authorFormGroup.get(['Usuario']).setValue(user.value);
                      this.authorFormGroup.get(['Nombre']).setValue(user.stringValue);
                    }
                }
                else if(this.selectedTask==13101 && this.bajaNueva=="ADMIN")
                {
                  this.authorFormGroup.get(['Tipo']).setValue('G');
                  
                  this.OnAuthorChange(this.authorList[0])
                  if(this.company)
                  {
                    this.authorFormGroup.get(['MedicoId']).setValue(null);
                      var user = this.GetUserByString(this.company.administrativa);
                      this.authorFormGroup.get(['Usuario']).setValue(user.value);
                      this.authorFormGroup.get(['Nombre']).setValue(user.stringValue);
                  }
                }
                else
                {
                    this.authorFormGroup.get(['Tipo']).setValue('G');
                    this.LoadUserDropdownList()
                    if(this.company)
                    {
                    var user = this.GetUserByString(this.company.administrativa);
                    }
                    this.OnAuthorChange(this.authorList[0])
                    // if(Boolean(currentUser.medicoId)) // current user is doctor
                    // {
                      if(this.company)
                      {
                      
                        this.authorFormGroup.get(['MedicoId']).setValue(null);
                        var user = this.GetUserByString(this.company.administrativa);
                        this.authorFormGroup.get(['Usuario']).setValue(user.value);
                        this.authorFormGroup.get(['Nombre']).setValue(user.stringValue);
                      }
                    // }
                    // else // current user is not doctor
                    // {               
                    //     this.authorFormGroup.get(['MedicoId']).setValue(null);
                    //     var user = this.GetUserByFind(currentUser.usuarioId);
                    //     this.authorFormGroup.get(['Usuario']).setValue(currentUser.usuarioId);
                    //     this.authorFormGroup.get(['Nombre']).setValue(currentUser.abreviacion);
                    // }
                }
            }
        }
        else if (this.moduleName=='proxima-actuacion')
        {
          if(this.selectedTask == 30101 || this.selectedTask == 31101)
          {
            this.authorFormGroup.get(['Tipo']).setValue('M');
            this.nextTaskFormGroup.get('TipoAutor').setValue('M');
              this.LoadMedicoDropdownList()
              this.OnAuthorChange(this.authorList[1])
                // if(Boolean(currentUser.medicoId)) // current user is doctor
                // {
                  this.authorFormGroup.get(['MedicoId']).setValue(this.LeaveInfo.medicoId);
                  var medico = this.GetMedicoByFind(this.LeaveInfo.medicoId);
                  this.authorFormGroup.get(['Medico']).setValue(this.LeaveInfo.medicoId);
                  if(medico)
                  {
                    this.authorFormGroup.get(['Nombre']).setValue(medico.viewValue);
                  }
                  this.nextTaskFormGroup.get('Author').setValue(this.LeaveInfo.medicoId);

                  
                  
                // }
                // else // current user is not doctor
                // {
                //   if(this.company)
                //   {
                //     this.authorFormGroup.get(['MedicoId']).setValue(this.company.medicoId.toString());
                //     var medico = this.GetMedicoByFind(this.company.medicoId);
                //     this.authorFormGroup.get(['Medico']).setValue(this.company.medicoId);
                //     if(medico)
                //     {
                //       this.authorFormGroup.get(['Nombre']).setValue(medico.viewValue);
                //     }
                //     this.nextTaskFormGroup.get('Author').setValue(this.company.medicoId);
                //   }
                // }
          }
          else
          {
              this.authorFormGroup.get(['Tipo']).setValue('G');
              this.nextTaskFormGroup.get('TipoAutor').setValue('G');
              this.LoadUserDropdownList()
              if(this.company)
              {
              var user = this.GetUserByString(this.company.administrativa);
              }
              this.OnAuthorChange(this.authorList[0])
              // if(Boolean(currentUser.medicoId)) // current user is doctor
              //   {
                  if(this.company)
                  {
                  
                    this.authorFormGroup.get(['MedicoId']).setValue(null);
                    var user = this.GetUserByString(this.company.administrativa);
                    this.authorFormGroup.get(['Usuario']).setValue(user.value);
                    this.authorFormGroup.get(['Nombre']).setValue(user.stringValue);

                    this.nextTaskFormGroup.get('Author').setValue(user.value);
                  }
                // }
                // else // current user is not doctor
                // {               
                //     this.authorFormGroup.get(['MedicoId']).setValue(null);
                //     var user = this.GetUserByFind(currentUser.usuarioId);
                //     this.authorFormGroup.get(['Usuario']).setValue(currentUser.usuarioId);
                //     this.authorFormGroup.get(['Nombre']).setValue(currentUser.abreviacion);

                //     this.nextTaskFormGroup.get('Author').setValue(currentUser.usuarioId);
                // }
          }
        }
        else if (this.moduleName=='solicitud-actuation')
        {
            this.LoadMedicoDropdownList()
              if(Boolean(currentUser.coordinador)) // current user is coordinator
              {
                this.authorFormGroup.get('Tipo').setValue('C')
                this.OnAuthorChange(this.authorList[2])
                this.authorFormGroup.get(['Coordinator']).setValue(Number(currentUser.coordinador));
                var cordinator = this.GetCoordinatorByFind(Number(currentUser.coordinador));
                this.authorFormGroup.get(['Nombre']).setValue(cordinator.viewValue);

                this.solicitudFormGroup.get(['Author','Tipo']).setValue("C");
                this.solicitudFormGroup.get(['Author','Coordinator']).setValue(Number(currentUser.coordinador))
                this.solicitudFormGroup.get(['Author','Nombre']).setValue(cordinator.viewValue)
              }
              else if(Boolean(currentUser.medicoId)) // current user is doctor
              {
                  this.authorFormGroup.get('Tipo').setValue('M')
                  this.OnAuthorChange(this.authorList[1])
                  this.authorFormGroup.get(['MedicoId']).setValue(currentUser.medicoId);
                  var medico = this.GetMedicoByFind(currentUser.medicoId);
                  this.authorFormGroup.get(['Medico']).setValue(currentUser.medicoId);
                  if(medico)
                  {
                    this.authorFormGroup.get(['Nombre']).setValue(medico.viewValue);
                  }
                 
                  this.solicitudFormGroup.get(['Author','Tipo']).setValue("M");
                  this.solicitudFormGroup.get(['Author','Medico']).setValue(currentUser.medicoId)
                  this.solicitudFormGroup.get(['Author','MedicoId']).setValue(Number(currentUser.medicoId))
                  if(medico)
                  {
                  this.solicitudFormGroup.get(['Author','Nombre']).setValue(medico.viewValue)
                  }
                  
              }
        }
        else if (this.moduleName=='app-gestion' || this.moduleName=='app-orden')
        {
          this.LoadMedicoDropdownList()
          if(this.authorFormGroup.get(['Tipo'])?.value=='G')
          {
            var user = this.GetUserByFind(currentUser.usuarioId);
            this.authorFormGroup.get(['Usuario']).setValue(currentUser.usuarioId);
            this.authorFormGroup.get(['Nombre']).setValue(currentUser.abreviacion);

            this.gestionFormGroup.get(['AutorInput']).setValue('G')
            this.gestionFormGroup.get(['TipoAutor']).setValue('G')

            var users = this.GetUserById(Number(currentUser.usuarioId));
            this.gestionFormGroup.get(['OtherAutorInput']).setValue(currentUser.usuarioId);
            this.gestionFormGroup.get(['Autor']).setValue(users.stringValue);
            this.gestionFormGroup.get(['Doctor']).setValue('');

          }
          else if(this.authorFormGroup.get(['Tipo'])?.value=='C')
          {
            if(Boolean(currentUser.coordinador)) // current user is coordinator
            {
              this.authorFormGroup.get(['Coordinator']).setValue(Number(currentUser.coordinador));
              var cordinator = this.GetCoordinatorByFind(Number(currentUser.coordinador));
              this.authorFormGroup.get(['Nombre']).setValue(cordinator.viewValue);

              this.gestionFormGroup.get(['AutorInput']).setValue('C')
              this.gestionFormGroup.get(['TipoAutor']).setValue('C')

              this.gestionFormGroup.get(['OtherAutorInput']).setValue(Number(currentUser.coordinador));
              this.gestionFormGroup.get(['Autor']).setValue(cordinator.viewValue);
              this.gestionFormGroup.get(['Doctor']).setValue('');

            }
          }
          else if(this.authorFormGroup.get(['Tipo'])?.value=='M')
          {
            if(Boolean(currentUser.medicoId)) // current user is medico
            {
              this.authorFormGroup.get(['MedicoId']).setValue(currentUser.medicoId);
              var medico = this.GetMedicoByFind(currentUser.medicoId);
              this.authorFormGroup.get(['Medico']).setValue(currentUser.medicoId);
              if(medico)
              {
              this.authorFormGroup.get(['Nombre']).setValue(medico.viewValue);
              }

              this.gestionFormGroup.get(['AutorInput']).setValue('M')
              this.gestionFormGroup.get(['TipoAutor']).setValue('M')

              this.gestionFormGroup.get(['OtherAutorInput']).setValue(currentUser.medicoId);
              if(medico)
              {
              this.gestionFormGroup.get(['Autor']).setValue(medico.viewValue);
              }
              this.gestionFormGroup.get(['Doctor']).setValue(currentUser.medicoId);

            }
          }
          else if(this.authorFormGroup.get(['Tipo'])?.value=='U')
          {
            this.authorFormGroup.get(['Nombre']).setValue('MUTUA');

            this.gestionFormGroup.get(['AutorInput']).setValue('U')
            this.gestionFormGroup.get(['TipoAutor']).setValue('U')

            this.gestionFormGroup.get(['OtherAutorInput']).setValue('MUTUA');
            this.gestionFormGroup.get(['Autor']).setValue('MUTUA');
            this.gestionFormGroup.get(['Doctor']).setValue('');
            
          }
          else if(this.authorFormGroup.get(['Tipo'])?.value=='E')
          {
            this.authorFormGroup.get(['Nombre']).setValue('');
            this.gestionFormGroup.get(['AutorInput']).setValue('E')
            this.gestionFormGroup.get(['TipoAutor']).setValue('E')
            this.gestionFormGroup.get(['OtherAutorInput']).setValue('NONE')
            this.gestionFormGroup.get(['Doctor']).setValue('');
          }else if (this.selectedTask == 14011 || this.selectedTask == 14019){
            if (this.company !== undefined) {
              var user = this.GetUserByString(this.company.administrativa);
              this.gestionFormGroup.get(['TipoAutor']).setValue('G');
              this.gestionFormGroup.get(['AutorInput']).setValue('G');
              this.gestionFormGroup.get(['Autor']).setValue(user.stringValue);
              this.authorFormGroup.get(['Usuario']).setValue(user.value);
              this.authorFormGroup.get(['Nombre']).setValue(user.stringValue);
              this.authorFormGroup.get(['Tipo']).setValue('G');
              this.OnAuthorChange(this.authorList[0])
            }
          }
          else
          {
            if(Boolean(currentUser.coordinador)) // current user is coordinator
              {
                this.authorFormGroup.get('Tipo').setValue('C')
                if(this.moduleName=='app-orden'){
                  this.OnAuthorChange(this.authorList[1])
                }else{
                  this.OnAuthorChange(this.authorList[2])
                }
                this.authorFormGroup.get(['Coordinator']).setValue(Number(currentUser.coordinador));
                var cordinator = this.GetCoordinatorByFind(Number(currentUser.coordinador));
                this.authorFormGroup.get(['Nombre']).setValue(cordinator.viewValue);

                this.gestionFormGroup.get(['AutorInput']).setValue('C')
                this.gestionFormGroup.get(['TipoAutor']).setValue('C')

                this.gestionFormGroup.get(['OtherAutorInput']).setValue(Number(currentUser.coordinador));
                this.gestionFormGroup.get(['Autor']).setValue(cordinator.viewValue);
                this.gestionFormGroup.get(['Doctor']).setValue('');

              }
              else if(Boolean(currentUser.medicoId)) // current user is doctor
              {
                  this.authorFormGroup.get('Tipo').setValue('M')
                  this.OnAuthorChange(this.authorList[1])
                  this.authorFormGroup.get(['MedicoId']).setValue(currentUser.medicoId);
                  var medico = this.GetMedicoByFind(currentUser.medicoId);
                  this.authorFormGroup.get(['Medico']).setValue(currentUser.medicoId);
                  if(medico)
                  {
                  this.authorFormGroup.get(['Nombre']).setValue(medico.viewValue); 
                  }   

                  this.gestionFormGroup.get(['AutorInput']).setValue('M')
                  this.gestionFormGroup.get(['TipoAutor']).setValue('M')

                  this.gestionFormGroup.get(['OtherAutorInput']).setValue(currentUser.medicoId);
                  if(medico)
                  {
                  this.gestionFormGroup.get(['Autor']).setValue(medico.viewValue);
                  }
                  this.gestionFormGroup.get(['Doctor']).setValue(currentUser.medicoId);
              }
              else
              {
                this.authorFormGroup.get('Tipo').setValue('G')
                this.OnAuthorChange(this.authorList[0]);

                var users = this.GetUserById(Number(currentUser.usuarioId));
                this.gestionFormGroup.get(['OtherAutorInput']).setValue(currentUser.usuarioId);
                this.gestionFormGroup.get(['Autor']).setValue(users.stringValue);
                this.gestionFormGroup.get(['Doctor']).setValue(users.stringValue);
              }
          }
          
        }
        else if (this.moduleName=='author-dialog')
        {
          this.LoadMedicoDropdownList()
          this.LoadUserDropdownList()
          this.LoadCoordinatorDropdownList()
          if(this.editAuthorFormGroup.get('Tipo')?.value=='M')
          {
            this.authorFormGroup.get('Tipo').setValue('M')
            this.OnAuthorChange(this.authorList[1])

            const medicoId=this.editAuthorFormGroup.get('Medico')?.value
            if(medicoId)
            {
              var medico = this.GetMedicoByFind(medicoId);
              this.authorFormGroup.get(['Medico']).setValue(medicoId);
              if(medico)
              {
                this.authorFormGroup.get(['Nombre']).setValue(medico.viewValue);
              }
             
            }
          }
          else
          {
            const tipo = this.editAuthorFormGroup.get('Tipo')?.value
            if(tipo=='G')
            { 
              this.authorFormGroup.get('Tipo').setValue('G')
              this.OnAuthorChange(this.authorList[0])
            }
            else if(tipo=='C')
            {
              this.authorFormGroup.get('Tipo').setValue('C')
              this.OnAuthorChange(this.authorList[2])
            }
            else if(tipo=='E')
            {
              this.authorFormGroup.get('Tipo').setValue('E')
              this.OnAuthorChange(this.authorList[3])
            }
            else if(tipo=='U')
            {
              this.authorFormGroup.get('Tipo').setValue('U')
              this.OnAuthorChange(this.authorList[4])
            }
           

            this.authorFormGroup.get('Tipo').setValue(this.editAuthorFormGroup.get('Tipo')?.value)
          }
         
        }

  }
  GetCoordinatorByFind(id){
    return this.coordinatorList.find(x => x.value === id);
}
  GetMedicoByFind(id){
      return this.medicoList.find(x => x.value === id);
  }
  GetUserByFind(id){
    return this.userList.find(x => x.value === id);
  }
  GetUserByString(id){
    return this.userList.find(x => x.stringValue === id);
  }
  GetUserById(id){
    return this.userList.find(x => x.value === id);
  }
  

  SetFormGroupControlValuesForOtherUser(nombre: string, medicoId: any): void {
      this.authorFormGroup.get('Nombre').patchValue(nombre);
      this.authorFormGroup.get('MedicoId').patchValue(medicoId);
  }

  OnUserChange(event): void {
    this._medicoList=this.medicoList;
    setTimeout(() => {
      this.doctorSearchInput.nativeElement.value=null;
    }, 1000);

    if(this.moduleName=='task-managemnt')
    {
        const selectedvalue =
            this.authorFormGroup.get('Tipo').value === 'M' ? event.value : null;
        const selectedSource = event.source.selected;
        const selectedViewValue =
            this.authorFormGroup.get('Tipo').value === 'G'
                ? this.userList.filter((e) => e.value === event.value)[0]
                      .stringValue
                : selectedSource.viewValue;
        this.SetFormGroupControlValuesForOtherUser(
            selectedViewValue,
            selectedvalue
        );
    }
    else if(this.moduleName=='task-selection')
    {
        if (event) {
          const selectedViewValue = event.source.selected.viewValue;
          const selectedValue = event.source.selected.value;
          const obj = { selectedValue, selectedViewValue };

          switch (this.authorFormGroup.get('Tipo').value) {
              case 'G':
                  this.UserChanged.emit(event.value);
                  break;
              case 'M':
                  this.MedicoChanged.emit(obj);
                  break;
              case 'C':
                  this.CoordinatorChanged.emit(selectedViewValue);
                  break;
              case 'D':
                  this.UserChanged.emit(event.value);
                  break;
              default:
                  break;
          }
        }
    }
    else if(this.moduleName=='proxima-actuacion')
    {
      if (event) {
        this.nextTaskFormGroup.get('Author').setValue(event.value);
      }
    }
    else if(this.moduleName=='solicitud-actuation')
    {
      if (this.authorFormGroup.get('Tipo').value =="M")
      {
        //this. ClearMainForm();

        this.solicitudFormGroup.get(['Author','Usuario']).setValue('');
        this.solicitudFormGroup.get(['Author','Coordinator']).setValue('');

        var medico = this.GetMedicoByFind(event.value);
        this.solicitudFormGroup.get(['Author','Tipo']).setValue("M");
        this.solicitudFormGroup.get(['Author','Medico']).setValue(event.value);
        this.solicitudFormGroup.get(['Author','MedicoId']).setValue(Number(event.value));
        if(medico)
        {
        this.solicitudFormGroup.get(['Author','Nombre']).setValue(medico.viewValue);
        }

        
      }
      else if(this.authorFormGroup.get('Tipo').value =="C")
      {
        this.solicitudFormGroup.get(['Author','Medico']).setValue('');
        this.solicitudFormGroup.get(['Author','MedicoId']).setValue('');
       
        var cordinator = this.GetCoordinatorByFind(Number(event.value));
        this.solicitudFormGroup.get(['Author','Tipo']).setValue("C");
        this.solicitudFormGroup.get(['Author','Coordinator']).setValue(Number(event.value));
        this.solicitudFormGroup.get(['Author','Nombre']).setValue(cordinator.viewValue);
      
      }
      else if(this.authorFormGroup.get('Tipo').value =="G")
      {
        this.solicitudFormGroup.get(['Author','Medico']).setValue('');
        this.solicitudFormGroup.get(['Author','MedicoId']).setValue('');
        this.solicitudFormGroup.get(['Author','Coordinator']).setValue('');

        var users = this.GetUserById(Number(event.value));
        this.solicitudFormGroup.get(['Author','Tipo']).setValue("G");
        this.solicitudFormGroup.get(['Author','Usuario']).setValue(Number(event.value));
        this.solicitudFormGroup.get(['Author','Nombre']).setValue(users.stringValue);
      }
    }
    else if(this.moduleName=='app-gestion' || this.moduleName=='app-orden')
    {
      if (this.authorFormGroup.get('Tipo').value =="M")
      {

        var medico = this.GetMedicoByFind(event.value);
        this.gestionFormGroup.get(['AutorInput']).setValue('M')
        this.gestionFormGroup.get(['TipoAutor']).setValue('M')

        this.gestionFormGroup.get(['OtherAutorInput']).setValue(event.value);
        if(medico)
        {
        this.gestionFormGroup.get(['Autor']).setValue(medico.viewValue);
        }
        this.gestionFormGroup.get(['Doctor']).setValue(event.value);

        
      }
      else if(this.authorFormGroup.get('Tipo').value =="C")
      {
        var cordinator = this.GetCoordinatorByFind(Number(event.value));
        this.gestionFormGroup.get(['AutorInput']).setValue('C')
        this.gestionFormGroup.get(['TipoAutor']).setValue('C')

        this.gestionFormGroup.get(['OtherAutorInput']).setValue(Number(event.value));
        this.gestionFormGroup.get(['Autor']).setValue(cordinator.viewValue);
        this.gestionFormGroup.get(['Doctor']).setValue('');
      
      }
      else if(this.authorFormGroup.get('Tipo').value =="G")
      {
        var user = this.GetUserByFind(event.value);

        this.gestionFormGroup.get(['AutorInput']).setValue('G')
        this.gestionFormGroup.get(['TipoAutor']).setValue('G')

        var users = this.GetUserById(Number(event.value));
        this.gestionFormGroup.get(['OtherAutorInput']).setValue(event.value);
        this.gestionFormGroup.get(['Autor']).setValue(users.stringValue);
        this.gestionFormGroup.get(['Doctor']).setValue('');
      }
    }
    else if(this.moduleName=='author-dialog')
    {
      const tipo = this.authorFormGroup.get('Tipo')?.value
      if(tipo=='M')
      {
        var medico = this.GetMedicoByFind(event.value);
        this.editAuthorFormGroup.get(['Medico']).setValue(event.value);
        this.editAuthorFormGroup.get(['MedicoId']).setValue(event.value);
        if(medico)
        {
        this.editAuthorFormGroup.get(['Nombre']).setValue(medico.viewValue);
        }
        this.editAuthorFormGroup.get(['Coordinator']).setValue('');
        this.editAuthorFormGroup.get(['Usuario']).setValue('');
      }
      if(tipo=='C')
      {
        var cordinator = this.GetCoordinatorByFind(event.value);
        this.editAuthorFormGroup.get(['Medico']).setValue('');
        this.editAuthorFormGroup.get(['MedicoId']).setValue('');
        this.editAuthorFormGroup.get(['Nombre']).setValue(cordinator.viewValue);
        this.editAuthorFormGroup.get(['Coordinator']).setValue(event.value);
        this.editAuthorFormGroup.get(['Usuario']).setValue('');
      }
      if(tipo=='G')
      {
        var user = this.GetUserByFind(event.value);
        this.editAuthorFormGroup.get(['Medico']).setValue('');
        this.editAuthorFormGroup.get(['MedicoId']).setValue('');
        this.editAuthorFormGroup.get(['Nombre']).setValue(user.stringValue);
        this.editAuthorFormGroup.get(['Coordinator']).setValue('');
        this.editAuthorFormGroup.get(['Usuario']).setValue(event.value);
      }
      if(tipo=='G')
      {
        
      }
      
    }
  }

  ClearMainForm()
  {
    this.authorFormGroup.get(['MedicoId']).setValue('');
    this.authorFormGroup.get(['Medico']).setValue('');
    this.authorFormGroup.get(['Nombre']).setValue('');
    this.authorFormGroup.get(['Usuario']).setValue('');
    this.authorFormGroup.get(['Coordinator']).setValue('');
  }

  OnAuthorChange(event): void {
      const selectedViewValue = event.viewValue;
      const selectedValue = event.value;
      this.AutorChanged.emit(selectedValue);

      const authorValue=event.value;
      this. SetSecondDropDown(authorValue)

      if(this.moduleName=='proxima-actuacion')
      {
        this.nextTaskFormGroup.get('TipoAutor').setValue(authorValue);
        if(authorValue=='G'){
            var user = this.GetUserByString(this.company.administrativa);
            this.authorFormGroup.get(['Usuario']).setValue(user.value);
            this.authorFormGroup.get(['Nombre']).setValue(user.stringValue);
        }

        if(authorValue=='M'){
          this.authorFormGroup.get(['MedicoId']).setValue(this.LeaveInfo.medicoId);
        }
      }
      if(this.moduleName=='solicitud-actuation')
      {
        this. ClearMainForm();
        this.solicitudFormGroup.get(['Author','Tipo']).setValue(authorValue);
        this.solicitudFormGroup.get(['Author','Nombre']).setValue('');
        this.solicitudFormGroup.get(['Author','MedicoId']).setValue('');
        this.solicitudFormGroup.get(['Author','Medico']).setValue('');
        this.solicitudFormGroup.get(['Author','Coordinator']).setValue('');
      }
      else if (this.moduleName=='author-dialog')
      {
        this. ClearMainForm();
        this.editAuthorFormGroup.get('Tipo').setValue(authorValue);
        if(authorValue=='U')
        {
          this.editAuthorFormGroup.get(['Medico']).setValue('');
          this.editAuthorFormGroup.get(['MedicoId']).setValue('');
          this.editAuthorFormGroup.get(['Nombre']).setValue('MUTUA');
          this.editAuthorFormGroup.get(['Coordinator']).setValue('');
          this.editAuthorFormGroup.get(['Usuario']).setValue(event.value);
        }
      }else if (this.moduleName=='task-managemnt')
      {
        if(!this.company){
          this.LoadAllInformations();
        }else{
          if(selectedValue == "M"){
            this.authorFormGroup.get(['MedicoId']).setValue(this.LeaveInfo.medicoId);
            var medico = this.GetMedicoByFind(this.LeaveInfo.medicoId);
            this.authorFormGroup.get(['Medico']).setValue(this.LeaveInfo.medicoId);
            if(medico)
            {
              this.authorFormGroup.get(['Nombre']).setValue(medico.viewValue);
            }
          }
          
          if(selectedValue == "G"){
            this.authorFormGroup.get(['MedicoId']).setValue(null);
            var user = this.GetUserByString(this.company.administrativa);
            this.authorFormGroup.get(['Usuario']).setValue(user.value);
            this.authorFormGroup.get(['Nombre']).setValue(user.stringValue);
          }
        }
      }


  }

  OnValueChange(event: any, type: string): void {
      if (event) {
          const selectedViewValue = event.source.selected.viewValue;
          const selectedValue = event.source.selected.value;
          const obj = { selectedValue, selectedViewValue };

          switch (type) {
              case 'user':
                  const abbreviation = this.userList.filter(
                      (e) => e.value === selectedValue
                  )[0].stringValue;
                  this.UserChanged.emit(abbreviation);
                  break;
              case 'doctor':
                  this.MedicoChanged.emit(obj);
                  break;
              case 'coordinator':
                  this.CoordinatorChanged.emit(selectedViewValue);
                  break;
              default:
                  break;
          }
      }
  }

  SetSecondDropDown(authorValue)
    {
      let selectedIndex = 0;
      if(authorValue=="E" || authorValue=="U" )//Empresa , Mutua
      {
        this.dropDownActivate.gestion = false;
        this.dropDownActivate.medico = false;
        this.dropDownActivate.coordinador = false;
        this.dropDownActivate.due = false;
      }
      else if(authorValue=="C")//Coordinador
      {
        this.LoadCoordinatorDropdownList();
        this.dropDownActivate.gestion = false;
        this.dropDownActivate.medico = false;
        this.dropDownActivate.coordinador = true;
        this.dropDownActivate.due = false;
      }
      else if(authorValue=="M")//Medico
      {

        this.LoadMedicoDropdownList();

        this.dropDownActivate.gestion = false;
        this.dropDownActivate.medico = true;
        this.dropDownActivate.coordinador = false;
        this.dropDownActivate.due = false;
      }
      else if(authorValue=="G")//Gestión
      {
        this.LoadUserDropdownList();
        this.dropDownActivate.gestion = true;
        this.dropDownActivate.medico = false;
        this.dropDownActivate.coordinador = false;
        this.dropDownActivate.due = false;
      }else if(authorValue=="D")//Due
      {
        this.LoadDueDropdownList();

        this.dropDownActivate.gestion = false;
        this.dropDownActivate.medico = false;
        this.dropDownActivate.coordinador = false;
        this.dropDownActivate.due = true;
      }
  }

  LoadUserDropdownList(): void {
      this.taskService.GetUsersAbreviacion().subscribe((res) => {
          if (res) {
              this.userList = res.result;
          }
      });
  }

  LoadMedicoDropdownList(): void {
        this.doctorService.GetActiveDoctorsDropdown().subscribe((res) => {
            if (res) {
              this.medicoList = res;
              this._medicoList=res;
              
            }
        });
  }

  LoadDueDropdownList(): void {
    this.doctorService.GetActiveDueDropdown().subscribe((res) => {
        if (res) {
          this.medicoList = res;
          this._medicoList=res;
        }
    });
}

  LoadCoordinatorDropdownList(): void {
        this.taskService.GetActiveCoordinator().subscribe((res) => {
            if (res) {
                this.coordinatorList = res.result;
            }
        });
  }

  GetLoggedUseTipoAutor(): void {
      this.currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) 
      if (this.currentUser.medicoId != null) {
          this.loggedUserTipoAutor = 'M';
      } else if (this.currentUser.coordinador != null) {
          this.loggedUserTipoAutor = 'C';
      } else {
          this.loggedUserTipoAutor = 'G';
      }
  }


}
